import { useEffect, useState } from 'react';
import { apiFetch } from '../auth/apiClient';

export default function useInterventionAssessmentNarratives({
  caseId, interventionId, active, editable, form, setForm, initialFormRef,
}) {
  const [error, setError] = useState(null);
  const [attempt, retry] = useState(0);
  const planId = form.actionPlanId;
  const scope = `${caseId}:${planId}:${interventionId || 'new'}`;
  const ready = form.narrativeScope === scope && !(editable && form.narrativesFromLegacySnapshot);
  useEffect(() => {
    if (!active || !caseId || !planId || ready) return undefined;
    let cancelled = false;
    setError(null);
    const query = interventionId ? `?interventionId=${encodeURIComponent(interventionId)}` : '';
    apiFetch(`/api/action-plans/${encodeURIComponent(planId)}/assessment-narratives${query}`)
      .then(async response => {
        const result = await response.json();
        if (!response.ok) throw new Error(result.message || 'Assessment wording could not be loaded.');
        if (cancelled) return;
        const fields = {
          ...(editable && !result.hasSavedFields ? result.defaults : result.saved),
          narrativeScope: scope,
          narrativesFromLegacySnapshot: !editable && !result.hasSavedFields,
        };
        setForm(previous => ({ ...previous, ...fields }));
        // Prefilling a legacy saved assessment is a real correction. Keep its
        // original baseline so Save revision records it even without retyping.
        if (!editable || result.hasSavedFields || !interventionId) {
          initialFormRef.current = { ...initialFormRef.current, ...fields };
        }
      })
      .catch(failure => { if (!cancelled) setError(failure.message); });
    return () => { cancelled = true; };
  }, [active, caseId, planId, interventionId, editable, scope, ready, attempt, setForm, initialFormRef]);
  return { ready, error, retry: () => retry(value => value + 1) };
}
